//
// Module for the _PortalRequestDetail partial view
//
rs.module("content/participant/account/communications/portalrequestdetail",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, documentGridApi) {

            var documentsModal = $.js(jsSelectors.documentsModal);
            var documentsForm = documentsModal.js(jsSelectors.documentsForm);
            var portalRequestDocumentKeyHidden = documentsForm.js(jsSelectors.portalRequestDocumentKeyHidden);

            // reset form validation when detail is loaded
            $.validator.resetValidation(documentsForm);

            // open the available documents modal when a link document link is clicked
            $.js(jsSelectors.linkDocumentLink, { required: false, multiple: true }).on("click", function () {

                // remove any prior messages 
                eventBanner.removeAllMessages();

                // clear any prior selections 
                documentGridApi.selectedValues = null;

                // clear field level errors
                documentsForm.clearErrors();

                // update the PortalRequestDocumentKey hidden field for posting
                portalRequestDocumentKeyHidden.val($(this).data("portalrequestdocumentkey"));

                // open the modal
                documentsModal.modal("show");
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);